<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M5.333 4h7.12c.737 0 1.334.597 1.334 1.333 0 .693-.53 1.263-1.205 1.328l-.129.006h-7.12c-.693 0-1.262.528-1.327 1.205L4 8v18.667c0 .693.529 1.262 1.205 1.327l.128.006H24c.693 0 1.263-.529 1.327-1.205l.006-.128v-7.12c0-.737.597-1.334 1.334-1.334.693 0 1.262.53 1.327 1.205l.006.129v7.12c0 2.142-1.684 3.89-3.8 3.995l-.2.005H5.333c-2.142 0-3.89-1.684-3.995-3.8l-.005-.2V8c0-2.142 1.684-3.891 3.8-3.995l.2-.005h7.12zm19.61-2.276l5.333 5.333c.52.52.52 1.365 0 1.886L16.943 22.276c-.25.25-.59.39-.943.39h-5.333c-.737 0-1.334-.596-1.334-1.333V16c0-.354.14-.693.39-.943L23.058 1.724c.52-.52 1.365-.52 1.886 0zM24 4.552l-12 12V20h3.448l12-12L24 4.552z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-edit",
  components: {},
})
export class IconEdit extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconEdit;
</script>
